import { CommentType } from '../models/airport-comment.model';
import { ContactType } from '../models/contact.model';
var ContactListingComponent = /** @class */ (function () {
    function ContactListingComponent() {
        this.ContactType = ContactType;
    }
    Object.defineProperty(ContactListingComponent.prototype, "ownerMgrRemarks", {
        get: function () {
            return (this.remarks || []).filter(function (remark) { return remark.commentType === CommentType.OwnerMgr; });
        },
        enumerable: true,
        configurable: true
    });
    return ContactListingComponent;
}());
export { ContactListingComponent };
